import React, { useEffect, useRef } from 'react';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { useBooking } from '../../../../contexts/ticketBookingContext/TicketBookingContext';
import useTranslation from '../../../../hooks/translation/useTranslation';
import useQuery from '../../../../hooks/useQuery';

function BookingTimer({ className = '' }) {
  const navigate = useNavigate();
  const ref = useRef();
  const { statement } = useBooking();

  const query = useQuery();

  const { trans } = useTranslation();

  const seatFormation = query.get('seatFormation');

  const show = seatFormation === 'select' || seatFormation === 'auto' || seatFormation === 'book';

  useEffect(() => {
    const calculateRemainingTime = () => {
      if (!statement?.expirationDate) return;
      const endTime = moment(statement?.expirationDate);
      const currentTime = moment();
      const duration = moment.duration(endTime.diff(currentTime));
      if (duration.asSeconds() <= 0) {
        navigate('/ka');
      }
      const minutes = duration.minutes();
      const seconds = duration.seconds();
      if (ref?.current) {
        ref.current.textContent = `${minutes?.toString()?.padStart(2, '0')}:${seconds?.toString()?.padStart(2, '0')}`;
      }
    };

    calculateRemainingTime();

    const interval = setInterval(() => {
      calculateRemainingTime();
    }, 1000);

    return () => clearInterval(interval);
  }, [statement?.expirationDate]);

  return show && statement?.expirationDate && (
    <div className={`py-5 w-full justify-center gap-2 hidden lg:flex ${className}`}>
      {trans('ticket_purchase_time_left')}
      :
      <span className="font-bold text-base text-black" ref={ref} />
    </div>
  );
}

export default BookingTimer;
